<template>
  <div class="couerss_body">

    <van-tabs v-model="active" @click="getdata">
      <van-search v-model="value" placeholder="请输入搜索关键词"/>
      <van-tab title="未付款" name="0">
        <van-empty description="暂时没有订单！" v-if="this.list==null || this.list.length==0"/>
        <div class="neirong"  v-for="item in list">
          <div style="margin-top: 10px">
            <dl>
              <dt><img :src="item.covermap" width="100%" alt=""></dt>
              <dd style="overflow: hidden;text-overflow: ellipsis;width: 230px;white-space: nowrap;">
                {{item.titles}}</dd>
              <dd>￥{{item.fee}}
                <button @click="quxiao(item)">取消订单</button>
                <button @click="show1=true">立即支付</button>
              </dd>
            </dl>
            <div>
              <p><span>状态</span><span>未付款</span></p>
              <p><span>购买时间</span><span>{{item.addtime}}</span></p>
            </div>
            <van-popup v-model="show1" position="bottom" :style="{ height: '50%' }">
              <div class="zhifu">
                <h3>确认支付</h3>
                <div class="qian">{{item.fee}}</div>
                <van-divider/>
                <div class="zhifufangshi">支付方式</div>
                <van-radio-group v-model="radio">
                  <van-cell-group>
                    <van-cell title="微信支付" clickable @click="radio = '1'">
                      <template #right-icon>
                        <van-radio name="1"/>
                      </template>
                    </van-cell>
                    <van-cell title="余额支付" clickable @click="radio = '2'">
                      <template #right-icon>
                        <van-radio name="2"/>
                      </template>
                    </van-cell>
                  </van-cell-group>
                </van-radio-group>
                <van-button type="warning" size="large" style="margin-top: 10px;" @click="zhifu(item)">确认支付</van-button>
              </div>
            </van-popup>
          </div>

        </div>
      </van-tab>
      <van-tab title="已付款" name="1">
        <van-empty description="暂时没有订单！" v-if="this.list==null || this.list.length==0"/>
        <div class="neirong" v-for="item in list" @click="tiaozhuan(item)">
          <div style="margin-top: 10px">

            <dl>
              <dt><img :src="item.covermap" width="100%" alt=""></dt>
              <dd style="overflow: hidden;text-overflow: ellipsis;width: 230px;white-space: nowrap;">
                {{item.titles}}<span>老师：{{item.teacher}}</span></dd>
              <dd>￥{{item.fee}}
                <button @click="evaluate(item)">立即评价</button>
              </dd>
            </dl>
            <div>
              <p><span>状态</span><span>已付款</span></p>
              <p><span>购买时间</span><span>{{item.paytime}}</span></p>
              <!--            <p><span>截止时间</span><span>2020-04-30</span></p>-->
            </div>
          </div>
        </div>
      </van-tab>

    </van-tabs>


  </div>
</template>

<script>
    import {Toast} from 'vant';
    import {Dialog} from 'vant';
    import wx from 'weixin-js-sdk'

    export default {
        name: "Courses",
        data() {
            return {
                radio: '1',
                show1: false,
                active: '0',
                value: '',
                list: [],
                ids: '',
                jine:''
            }
        },
        created() {
            this.getdata()
        },
        methods: {
            tiaozhuan(item){
                this.$router.push({path: '/group', query: {id: item.cid}})
            },
            evaluate(item) {
                this.$router.push({path: '/pingjia', query: {id: item.id}})
            },
            quxiao(item) {
                this.myrequest({
                    url: '/client/delorder.action',
                    types: 'post',
                    data: {
                        token: this.$store.state.token,
                        orderid: item.id,
                        code:2
                    },
                    succ: (res) => {

                        Toast.success('取消订单成功');
                        this.getdata()
                        // this.$router.go(-1)
                    },
                    errs: (msg) => {
                        Toast.fail('取消订单失败');
                    }
                })
            },
            getdata() {
                this.myrequest({
                    url: '/client/getcurrorderlist.action',

                    types: 'get',
                    data: {
                        // token:this.$store.state.token
                        orderstatus: this.active
                    },
                    succ: (res) => {
                      console.log(res)
                        this.list = res.data
                        console.log(this.active, 1212)
                    },
                    errs: (msg) => {

                    }
                })
            },

            zhifu(item) {
                if(this.radio==2){
                  console.log(item.id)
                    this.myrequest({
                        url: '/client/paymentorder.action',
                  /*/addpackagecurriculumorder.action*/

                      types: 'post',
                        data: {
                            token: this.$store.state.token,
                            orderid: item.id,
                            code:2,
                        },
                        succ: (res) => {
                            Dialog.confirm({
                                title: '提示',
                                message: '支付成功,是否立即前去观看视频',
                            })
                                .then(() => {
                                    // on confirm
                                    console.log(item.cid)
                                    this.$router.push({path: '/group',query:{id:item.cid}})

                                })
                                .catch(() => {
                                    this.$router.push({path: '/'})
                                });

                            this.getdata()
                            // this.$router.go(-1)
                        },
                        errs: (msg) => {
                            Toast.fail(msg);
                        }
                    })
                }else if(this.radio==1){
                    this.myrequest({
                        url:'/client/wxpaymentorder.action',
                        types:'post',
                        data:{
                            // token:this.$store.state.token
                            orderid: item.id ,
                            code:2,
                        },
                        succ: (res) => {
                            wx.config({
                                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                                appId: this.$store.state.appid, // 必填，公众号的唯一标识
                                timestamp: this.$store.state.timestamp, // 必填，生成签名的时间戳
                                nonceStr: this.$store.state.nonceStr, // 必填，生成签名的随机串
                                signature: this.$store.state.signature,// 必填，签名
                                jsApiList: ['chooseImage', 'updateAppMessageShareData', 'updateTimelineShareData', 'chooseWXPay'] // 必填，需要使用的JS接口列表
                            });

                          
                            wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
                                wx.chooseWXPay({
                                    timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                                    nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
                                    package: res.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                                    signType: 'MD5', // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                                    paySign: res.data.paySign, // 支付签名
                                    success: function (res) {
                                        window.location.href = '/Coursess'
                                        // window.location.href = '/index/Mine/confirmOrder/orderDetails?ids=' + this.orderId
                                        // alert('111')
                                    },
                                    cancel: function (res) {
                                        // alert('1234')
                                        // alert(JSON.stringify(res))
                                        Toast.success('已取消支付');
                                    },
                                    fail: function (res) {
                                        // alert(12313)
                                    }
                                });
                            });

                        },
                        errs: (msg) => {

                        }
                    })
                }

            },
        }
    }
</script>

<style scoped lang="stylus">
  .couerss_body {
    position: absolute;
    width 100%;
    background-color #f1f1f1;
    min-height 100%

    .zhifu {
      width 100%;

      h3 {
        text-align center;
        color #333;
        font-weight 500
      }

      .zhifufangshi {
        margin-left 10px;
        margin-bottom 10px;
        font-size 14px;
      }

      .qian {
        text-align center;
        font-size 14px;
        font-weight 500;
        /*margin-top 10px*/
      }

      >>> .van-button--large {
        width 50%;
        margin auto;
        display block
      }

      >>> .van-button--warning {
        background-color red
      }
    }

    .neirong {
      width 95%;
      margin auto;
      background-color #ffffff;
      border-radius 5px
      /*height 200px*/

      > div {
        width: 100%

        h3 {
          font-size 11pt
          font-weight 500
          padding 10px 15px
          line-height 30px
          border-bottom 1px solid #eee
          margin-bottom 0

          img {
            width 30px
            height 30px
            border-radius 50%
            display inline-block
            margin-right 3px
            float left
          }
        }

        dl {
          padding 10px 15px
          margin 0
          overflow auto

          dt {
            width 80px
            height 80px
            float left
            margin-right 8px
          }

          dd:nth-of-type(1) {
            font-size 12pt
            font-weight 500
            line-height 40px

            span {
              font-size 8pt
              color #666
              float right
              font-weight 400
            }
          }

          dd:nth-of-type(2) {
            font-size 11pt
            line-height 200%
            color #e9353e
            font-weight 500

            button {
              background-color #ffebe8
              border none
              font-size 9pt
              border-radius 50px
              padding 0 12px
              float right
              margin-left 5px
              font-weight 400
            }
          }
        }

        > div {
          width 100%
          border-top 1px solid #eee
          display flex

          p {
            flex 33.3%
            display block
            text-align center
            border-right 1px dotted #eee

            span {
              display block
              font-size 10pt
              line-height 20px
            }

            span:first-child {
              font-size 8pt
              color: #666
            }
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/wode/Coursess.vue